import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PgBubbleService } from './pg-bubble.service';

@Component({
  selector: 'pg-bubble, grit-bubble',
  templateUrl: './pg-bubble.component.html',
  styleUrls: ['./pg-bubble.component.scss'],
  providers: [],
})
export class PgBubbleComponent implements OnInit {
  @ViewChild('canvas', { static: true })
  _canvasChild: ElementRef;
  get canvasEl(): HTMLCanvasElement {
    return this._canvasChild.nativeElement;
  }
  constructor() {}

  ngOnInit() {}
}
